import { createContext, useContext } from 'react';

const WidgetContext = createContext({
  widget: {},
  updateWidget() {}
});

export const useWidgetState = () => useContext(WidgetContext);

export default WidgetContext;
